<template>
  <div>
    <ValidationObserver ref="formAdd">
      <form @submit.prevent="">
        <div class="breadcrumb-area pos-relative w-100">
          <!-- title -->
          <div class="row">
            <h5 class="col-sm-6 col-12">Chi tiết quản lý bản giấy HĐ/PL</h5>
            <div class="col-sm-6 col-12 d-flex justify-content-end align-items-center">
              <b-button class="ml-2" @click="$router.push({ name: 'paperContractManager' })">
                Quay lại
              </b-button>
            </div>
          </div>
          <!-- content -->
          <div class="">
            <div class="row w-100">
              <div class="col-sm-6 mt-2">
                <div class="row mb-4">
                  <div class="col-3">Loại:</div>
                  <div class="col-9">{{ data.type === 'APPENDIX' ? 'Phụ Lục' : 'Hợp đồng' }}</div>
                </div>
                <div class="row mb-4">
                  <div class="col-3">Loại phụ lục:</div>
                  <div class="col-9">
                    {{ data.typeAppendix | transformData(Config.typeAppendix) }}
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-3">Mã HĐ:</div>
                  <div class="col-9 link" @click="linkContract(data.contractId)">
                    {{ data.contractCode }}
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-3">Mã PL:</div>
                  <div class="col-9">{{ data.appendixCode }}</div>
                </div>
                <div class="row mb-4">
                  <div class="col-3">Vùng KD:</div>
                  <div class="col-9">{{ data.region }}</div>
                </div>
                <div class="row mb-4">
                  <div class="col-3">Trạng thái:</div>
                  <div class="col-9">
                    {{ data.status | transformData(Config.listStatusContract) }}
                  </div>
                </div>
                <div class="row mb-4" v-if="data.createdDate">
                  <div class="col-3">Ngày tạo:</div>
                  <div class="col-9">{{ data.createdDate | formatDate('HH:mm DD/MM/YYYY') }}</div>
                </div>
                <div class="row mb-4" v-if="data.signDate">
                  <div class="col-3">Ngày ký:</div>
                  <div class="col-9">{{ data.signDate | formatDate('HH:mm DD/MM/YYYY') }}</div>
                </div>
                <div class="row mb-4" v-if="data.approveDate">
                  <div class="col-3">Ngày duyệt:</div>
                  <div class="col-9">{{ data.approveDate | formatDate('HH:mm DD/MM/YYYY') }}</div>
                </div>
                <div class="row mb-4" v-if="data.rejectDate">
                  <div class="col-3">Ngày từ chối:</div>
                  <div class="col-9">{{ data.rejectDate | formatDate('HH:mm DD/MM/YYYY') }}</div>
                </div>
                <div class="row mb-4" v-if="data.cancelDate">
                  <div class="col-3">Ngày hủy:</div>
                  <div class="col-9">{{ data.cancelDate | formatDate('HH:mm DD/MM/YYYY') }}</div>
                </div>
                <div class="row mb-4">
                  <div class="col-3">Người tạo:</div>
                  <div class="col-9">{{ data.createdByName }} - {{ data.createdByEmail }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import { ContractService } from '@/services/contract.service'
  export default {
    data() {
      return {
        Config,
        data: {},
        showLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      async fetchData() {
        this.showLoading = true
        try {
          const response = await ContractService.detailPaperContractManager({
            id: this.$route.params.id,
          })
          if (response.success) this.data = response.data.data
          console.log(response.data)
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      linkContract(id) {
        const routeData = this.$router.resolve({ path: `/contract-detail-paper/${id}` })
        window.open(routeData.href, '_blank')
      },
    },
  }
</script>
<style scoped>
  .link {
    cursor: pointer;
    color: blue;
  }
</style>
